import { Component, ViewEncapsulation } from '@angular/core';
import { CueShareData } from 'globals/store/programs.data';
import { environment } from '../../../environments/environment';
import publicHelpers from '../../helpers/public-helpers';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { ShareWrapper } from '../share/share-wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { CommonModule } from '@angular/common';
import { CueSheetViewComponent } from './cue-sheet-view.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { jsonCopyObject } from 'globals/helpers/helpers';

@Component({
    selector: 'cue-sheet-share',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="mode-toggle">
  <button (click)="toggleDarkMode()">{{ isDarkMode ? 'Dark Mode' : 'Light Mode' }}</button>
</div>

<ng-container *ngIf="data?.program as program">
  <h1 class="title">Run of show for {{ program.title || 'Untitled Program' }}, {{ data.eventTitle }}</h1>
  <ng-container *ngFor="let day of program.sessions; index as day_idx; first as first; last as day_last">
    <h3 class="date">{{ program | programDayDate:day.day }}</h3>
    <cue-sheet-view *ngFor="let session of day.sessions | idsToItems:program.sessions_obj"
      [readOnly]="true" 
      [cues]="data?.cues"
      [assets]="data?.assets" 
      [session]="session"
      [program]="program"
      [number]="sessionNumbers[session.id]"
    ></cue-sheet-view>
  </ng-container>
</ng-container>
<div class="unavailable" *ngIf="!loading && !data">{{ unavailableMessage }}</div>
  `,
    styleUrls: ['./cue-sheet-share.scss'],
    standalone: true,
    imports: [CommonModule, CueSheetViewComponent, ProgramDayDate, IdsToItemsPipe]
})
export class CueSheetShareComponent extends ShareWrapper<CueSheetShareComponent> {
  isDarkMode = false
  readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app

  publishCode:string;
  collapsedStates = {}
  
  baseShareUrl = environment.joi.shareBase
  helpers = publicHelpers
  error: string

  loading = true;
  unavailableMessage = "The run of show is currently not available.\n\nPlease contact the event organiser."
  data: CueShareData
  sessionNumbers: Dictionary<number> = {}

  constructor(private route:ActivatedRoute) {
    super()
    this.route.params.subscribe(params=>{
      if(!params || !params.hasOwnProperty('publishCode')) {
        this.loading = false;
        document.title = "Run of Show Unavailable";
      } else {
        this.publishCode = params.publishCode
        this.download(this.publishCode)
      }
      document.title = "loading";
    })
  }

  toggleDarkMode() {
    this.isDarkMode = !this.isDarkMode
    const body = document.body
    if (this.isDarkMode) {
      body.classList.add('dark')
    } else {
      body.classList.remove('dark')
    }
  }

  async download(publishCode) {
    console.log(publishCode)
    const url = `${this.api}/share-cues/${publishCode}`
    this.http.get(url).pipe(take(1)).subscribe((data: CueShareData) => {
      this.data = data
      console.log(data)
      document.title = `${data.program.title} run of show` || 'Untitled run of show'
      this.loading = false;
      
      if (data?.program) {
        const program = jsonCopyObject(data.program)
        let index = 1
        program.sessions.forEach(s => 
          s.sessions.map(sId => program.sessions_obj[sId]).filter(s => !!s).forEach(s => {
            this.sessionNumbers[s.id] = index
            index += 1
        }))

      }

    }, (error) => {
      console.log(error)
      this.loading = false;
      document.title = "Run of show unavailable";
    })
  }
}

